import { gql } from '@apollo/client';

const deleteReceipt = gql`
  mutation ($id: Int!) {
    deleteReceipt(id: $id)
  }
`;
export default deleteReceipt;
